<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" label-width="150px" v-loading="loading">
        <el-form-item prop="userName" label="客户：">
          {{ formData.userName || "-" }}
        </el-form-item>
        <!-- <el-form-item prop="ygId" label="商品名称：">
          {{ formData.ygId|| "-" }}
        </el-form-item> -->
        <el-form-item prop="ygTypeName" label="成品油类型：">
          {{ formData.oilTypeName || "-" }}
        </el-form-item>
        <el-form-item prop="unitPrice" label="每日/单价：">
          {{ formData.unitPrice || "-" }}
        </el-form-item>
        <el-form-item prop="ygUnitName" label="单位：">
          {{ formData.ygUnitName || "-" }}
        </el-form-item>
        <el-form-item prop="ygDate" label="开始计价日期：">
          {{ formData.ygDate || "-" }}
        </el-form-item>

        <el-form-item prop="ygPrice" label="合同金额：">
          {{ formData.ygPrice || "-" }}
        </el-form-item>
        <el-form-item prop="ygNumber" label="数量：">
          {{ formData.ygNumber || "-" }}
        </el-form-item>

        <el-form-item label="附件" prop="fileList">
          <file-upload readonly v-model="formData.fileList"></file-upload>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'CpyDetail',
  data () {
    return {
      formData: {},
      loading: false
    }
  },
  created () {
    if (this.ygId) {
      this.loadData()
    }
  },
  computed: {
    ygId () {
      return this.$route.query.ygId
    }
  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.oiltabkManage.selectYgUserInventoryByYgId, {
        params: { ygId: this.ygId }
      }).then(res => {
        this.formData = res || {}
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 450px;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
